import React, { useState, useEffect, useContext, useLayoutEffect } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import axios from "axios";
import Header from "../../layout/Header/Header";

import {
  Button,
  Row,
  Table,
  Input,
  Label,
  Col,
  Card,
  CardBody,
  CardTitle,
} from "reactstrap";
import moment from 'moment';

import Swal from "sweetalert2";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5plugins_exporting from "@amcharts/amcharts5/plugins/exporting";

function ReporteVentasPorVendedor() {
  const { user } = useContext(AuthContext);
  const URL_GRAFICAS = import.meta.env.VITE_URL_GRAFICAS;
  const URL_COLABORADORES = import.meta.env.VITE_URL_COLABORADORES;
  const URL_AREAS = import.meta.env.VITE_URL_AREAS;

  let hoy = new Date();
  let semanaAtras = new Date();
  semanaAtras.setDate(semanaAtras.getDate() - 30);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(semanaAtras).format("YYYY-MM-DD");

  const [datosCompletos, setDatosCompletos] = useState(null);
  const [colaboradores, setColaboradores] = useState([]);
  const [areas, setAreas] = useState([]);

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  const [selectedColaborador, setSelectedColaborador] = useState("todos");
  const [selectedArea, setSelectedArea] = useState("todos");

  const [cargando, setCargando] = useState(true);

  const Toast = Swal.mixin({
    toast: true,
    position: 'center',
    showConfirmButton: false,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })

  useEffect(() => {
    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        setColaboradores(response.data);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        setAreas(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const cargarDatos = () => {
    if (!selectedFechaInicio || !selectedFechaFin) return;
    if (selectedFechaInicio.length !== 10 || selectedFechaFin.length !== 10) {
      Toast.fire({
        icon: 'warning',
        title: 'Verifica las fechas'
      });
      return;
    }

    setCargando(true);
    Toast.fire({
      icon: 'info',
      title: 'Cargando datos...'
    });

    axios
      .get(`${URL_GRAFICAS}/prendasPorVendedor/${selectedFechaInicio}/${selectedFechaFin}/${selectedColaborador}/${selectedArea}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        setDatosCompletos(response.data);
        setCargando(false);
        Toast.close();
      })
      .catch((err) => {
        console.log(err);
        setCargando(false);
        Toast.close();
      });
  };

  useEffect(() => {
    cargarDatos();
  }, []);

  // Gráfica 1: Prendas por Vendedor
  useLayoutEffect(() => {
    if (!datosCompletos || !datosCompletos.porVendedor || datosCompletos.porVendedor.length === 0) return;

    let root = am5.Root.new("chartVendedor");
    root.setThemes([am5themes_Animated.new(root)]);

    let chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panY: false,
        layout: root.verticalLayout
      })
    );

    let data = datosCompletos.porVendedor;

    let yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        renderer: am5xy.AxisRendererY.new(root, {}),
        min: 0
      })
    );

    let xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        renderer: am5xy.AxisRendererX.new(root, { minGridDistance: 30 }),
        tooltip: am5.Tooltip.new(root, {}),
        categoryField: "vendedor"
      })
    );
    xAxis.data.setAll(data);

    xAxis.get("renderer").labels.template.setAll({
      oversizedBehavior: "truncate",
      maxWidth: 80,
      rotation: -45,
      centerY: am5.p50,
      centerX: am5.p100,
      paddingRight: 15,
      fontSize: 10
    });

    let series1 = chart.series.push(
      am5xy.ColumnSeries.new(root, {
        name: "Prendas",
        xAxis: xAxis,
        yAxis: yAxis,
        valueYField: "cantidad",
        categoryXField: "vendedor",
        tooltip: am5.Tooltip.new(root, {
          labelText: "{categoryX}: {valueY} prendas"
        })
      })
    );

    series1.columns.template.setAll({
      cornerRadiusTL: 0,
      cornerRadiusTR: 0,
      strokeOpacity: 0,
      width: am5.percent(70)
    });

    series1.set("fill", am5.color("#5B9BD5"));
    series1.data.setAll(data);

    if (data.length > 15) {
      chart.set("scrollbarX", am5.Scrollbar.new(root, { orientation: "horizontal" }));
    }

    chart.set("cursor", am5xy.XYCursor.new(root, {}));

    am5plugins_exporting.Exporting.new(root, {
      menu: am5plugins_exporting.ExportingMenu.new(root, {})
    });

    return () => { root.dispose(); };
  }, [datosCompletos]);

  // Gráfica 2: Top Artículos Más Vendidos
  useLayoutEffect(() => {
    if (!datosCompletos || !datosCompletos.topArticulos || datosCompletos.topArticulos.length === 0) return;

    let root = am5.Root.new("chartArticulos");
    root.setThemes([am5themes_Animated.new(root)]);

    let chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panY: false,
        layout: root.verticalLayout
      })
    );

    let data = datosCompletos.topArticulos;

    let yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        renderer: am5xy.AxisRendererY.new(root, {}),
        min: 0
      })
    );

    let xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        renderer: am5xy.AxisRendererX.new(root, { minGridDistance: 30 }),
        tooltip: am5.Tooltip.new(root, {}),
        categoryField: "articulo"
      })
    );
    xAxis.data.setAll(data);

    xAxis.get("renderer").labels.template.setAll({
      oversizedBehavior: "truncate",
      maxWidth: 70,
      rotation: -45,
      centerY: am5.p50,
      centerX: am5.p100,
      paddingRight: 15,
      fontSize: 9
    });

    let series1 = chart.series.push(
      am5xy.ColumnSeries.new(root, {
        name: "Cantidad",
        xAxis: xAxis,
        yAxis: yAxis,
        valueYField: "cantidad",
        categoryXField: "articulo",
        tooltip: am5.Tooltip.new(root, {
          labelText: "{categoryX}: {valueY} pzas"
        })
      })
    );

    series1.columns.template.setAll({
      cornerRadiusTL: 0,
      cornerRadiusTR: 0,
      strokeOpacity: 0,
      width: am5.percent(70)
    });

    series1.set("fill", am5.color("#70AD47"));
    series1.data.setAll(data);

    chart.set("cursor", am5xy.XYCursor.new(root, {}));

    am5plugins_exporting.Exporting.new(root, {
      menu: am5plugins_exporting.ExportingMenu.new(root, {})
    });

    return () => { root.dispose(); };
  }, [datosCompletos]);

  // Gráfica 3: Ventas por Área/Tienda
  useLayoutEffect(() => {
    if (!datosCompletos || !datosCompletos.porArea || datosCompletos.porArea.length === 0) return;

    let root = am5.Root.new("chartArea");
    root.setThemes([am5themes_Animated.new(root)]);

    let chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panY: false,
        layout: root.verticalLayout
      })
    );

    let data = datosCompletos.porArea;

    let yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        renderer: am5xy.AxisRendererY.new(root, {}),
        min: 0
      })
    );

    let xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        renderer: am5xy.AxisRendererX.new(root, { minGridDistance: 30 }),
        tooltip: am5.Tooltip.new(root, {}),
        categoryField: "area"
      })
    );
    xAxis.data.setAll(data);

    xAxis.get("renderer").labels.template.setAll({
      oversizedBehavior: "truncate",
      maxWidth: 80,
      rotation: -45,
      centerY: am5.p50,
      centerX: am5.p100,
      paddingRight: 15,
      fontSize: 10
    });

    let series1 = chart.series.push(
      am5xy.ColumnSeries.new(root, {
        name: "Prendas",
        xAxis: xAxis,
        yAxis: yAxis,
        valueYField: "cantidad",
        categoryXField: "area",
        tooltip: am5.Tooltip.new(root, {
          labelText: "{categoryX}: {valueY} prendas"
        })
      })
    );

    series1.columns.template.setAll({
      cornerRadiusTL: 0,
      cornerRadiusTR: 0,
      strokeOpacity: 0,
      width: am5.percent(70)
    });

    series1.set("fill", am5.color("#ED7D31"));
    series1.data.setAll(data);

    chart.set("cursor", am5xy.XYCursor.new(root, {}));

    am5plugins_exporting.Exporting.new(root, {
      menu: am5plugins_exporting.ExportingMenu.new(root, {})
    });

    return () => { root.dispose(); };
  }, [datosCompletos]);

  // Gráfica 4: Tendencia Diaria
  useLayoutEffect(() => {
    if (!datosCompletos || !datosCompletos.porDia || datosCompletos.porDia.length === 0) return;

    let root = am5.Root.new("chartDiario");
    root.setThemes([am5themes_Animated.new(root)]);

    let chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panX: true,
        panY: false,
        wheelX: "panX",
        wheelY: "zoomX",
        layout: root.verticalLayout
      })
    );

    let data = datosCompletos.porDia;

    let xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        categoryField: "fecha",
        renderer: am5xy.AxisRendererX.new(root, { minGridDistance: 50 }),
        tooltip: am5.Tooltip.new(root, {})
      })
    );
    xAxis.data.setAll(data);

    xAxis.get("renderer").labels.template.setAll({
      rotation: -45,
      centerY: am5.p50,
      centerX: am5.p100,
      paddingRight: 15,
      fontSize: 9
    });

    let yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        renderer: am5xy.AxisRendererY.new(root, {}),
        min: 0
      })
    );

    // Serie de línea para cantidad
    let series1 = chart.series.push(
      am5xy.LineSeries.new(root, {
        name: "Prendas",
        xAxis: xAxis,
        yAxis: yAxis,
        valueYField: "cantidad",
        categoryXField: "fecha",
        tooltip: am5.Tooltip.new(root, {
          labelText: "{categoryX}: {valueY} prendas"
        })
      })
    );

    series1.strokes.template.setAll({
      strokeWidth: 2
    });

    series1.bullets.push(function() {
      return am5.Bullet.new(root, {
        sprite: am5.Circle.new(root, {
          radius: 4,
          fill: series1.get("fill")
        })
      });
    });

    series1.set("stroke", am5.color("#4472C4"));
    series1.set("fill", am5.color("#4472C4"));
    series1.data.setAll(data);

    chart.set("cursor", am5xy.XYCursor.new(root, {}));

    if (data.length > 15) {
      chart.set("scrollbarX", am5.Scrollbar.new(root, { orientation: "horizontal" }));
    }

    am5plugins_exporting.Exporting.new(root, {
      menu: am5plugins_exporting.ExportingMenu.new(root, {})
    });

    return () => { root.dispose(); };
  }, [datosCompletos]);

  // Gráfica 5: Importe por Vendedor
  useLayoutEffect(() => {
    if (!datosCompletos || !datosCompletos.porVendedor || datosCompletos.porVendedor.length === 0) return;

    let root = am5.Root.new("chartImporteVendedor");
    root.setThemes([am5themes_Animated.new(root)]);

    let chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panY: false,
        layout: root.verticalLayout
      })
    );

    let data = [...datosCompletos.porVendedor].sort((a, b) => b.importe - a.importe);

    let yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        renderer: am5xy.AxisRendererY.new(root, {}),
        min: 0,
        numberFormat: "$#,###"
      })
    );

    let xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        renderer: am5xy.AxisRendererX.new(root, { minGridDistance: 30 }),
        tooltip: am5.Tooltip.new(root, {}),
        categoryField: "vendedor"
      })
    );
    xAxis.data.setAll(data);

    xAxis.get("renderer").labels.template.setAll({
      oversizedBehavior: "truncate",
      maxWidth: 80,
      rotation: -45,
      centerY: am5.p50,
      centerX: am5.p100,
      paddingRight: 15,
      fontSize: 10
    });

    let series1 = chart.series.push(
      am5xy.ColumnSeries.new(root, {
        name: "Importe",
        xAxis: xAxis,
        yAxis: yAxis,
        valueYField: "importe",
        categoryXField: "vendedor",
        tooltip: am5.Tooltip.new(root, {
          labelText: "{categoryX}: ${valueY}"
        })
      })
    );

    series1.columns.template.setAll({
      cornerRadiusTL: 0,
      cornerRadiusTR: 0,
      strokeOpacity: 0,
      width: am5.percent(70)
    });

    series1.set("fill", am5.color("#9E480E"));
    series1.data.setAll(data);

    if (data.length > 15) {
      chart.set("scrollbarX", am5.Scrollbar.new(root, { orientation: "horizontal" }));
    }

    chart.set("cursor", am5xy.XYCursor.new(root, {}));

    am5plugins_exporting.Exporting.new(root, {
      menu: am5plugins_exporting.ExportingMenu.new(root, {})
    });

    return () => { root.dispose(); };
  }, [datosCompletos]);

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 0
    }).format(value || 0);
  };

  return (
    <>
      <Header />
      <br />
      <br />
      <div className="container-fluid">
        <h3 align="center">Dashboard de Ventas por Vendedor</h3>
        {/* Misma base que Venta Mensual y que el calculo de Comisiones: el valor
            de la mercancia (subTotal), sin IVA, flete ni comision de tarjeta. */}
        <p align="center" style={{ color: "#6c757d", fontSize: "0.85rem", marginTop: "-6px" }}>
          Venta de mercancía &mdash; no incluye IVA, flete ni comisión de tarjeta
        </p>

        {/* Filtros */}
        <div className="card p-3 mb-3">
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => setSelectedFechaInicio(e.target.value)}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => setSelectedFechaFin(e.target.value)}
              />
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Vendedor</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedColaborador}
                onChange={(e) => setSelectedColaborador(e.target.value)}
              >
                <option value="todos">Todos los vendedores</option>
                {colaboradores
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((colaborador) => (
                    <option key={colaborador._id} value={colaborador._id}>
                      {colaborador.nombre} {colaborador.apellido}
                    </option>
                  ))}
              </Input>
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Área/Tienda</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedArea}
                onChange={(e) => setSelectedArea(e.target.value)}
              >
                <option value="todos">Todas las áreas</option>
                {areas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((area) => (
                    <option key={area._id} value={area._id}>
                      {area.name}
                    </option>
                  ))}
              </Input>
            </Col>
            <Col md={2} className="d-flex align-items-end">
              <Button
                size="sm"
                color="primary"
                block
                onClick={cargarDatos}
                disabled={cargando}
              >
                {cargando ? "Cargando..." : "Actualizar"}
              </Button>
            </Col>
          </Row>
        </div>

        {/* KPIs */}
        {datosCompletos && datosCompletos.resumen && (
          <Row className="mb-3">
            <Col md={2}>
              <Card className="text-center" style={{backgroundColor: '#5B9BD5', color: 'white'}}>
                <CardBody>
                  <CardTitle tag="h6">Total Prendas</CardTitle>
                  <h3>{datosCompletos.resumen.totalPrendas?.toLocaleString() || 0}</h3>
                </CardBody>
              </Card>
            </Col>
            <Col md={2}>
              <Card className="text-center" style={{backgroundColor: '#70AD47', color: 'white'}}>
                <CardBody>
                  <CardTitle tag="h6">Importe de Mercancía</CardTitle>
                  <h4>{formatCurrency(datosCompletos.resumen.totalImporte)}</h4>
                </CardBody>
              </Card>
            </Col>
            <Col md={2}>
              <Card className="text-center" style={{backgroundColor: '#ED7D31', color: 'white'}}>
                <CardBody>
                  <CardTitle tag="h6">Vendedores</CardTitle>
                  <h3>{datosCompletos.resumen.totalVendedores || 0}</h3>
                </CardBody>
              </Card>
            </Col>
            <Col md={2}>
              <Card className="text-center" style={{backgroundColor: '#4472C4', color: 'white'}}>
                <CardBody>
                  <CardTitle tag="h6">Prom. x Vendedor</CardTitle>
                  <h3>{datosCompletos.resumen.promedioVendedor?.toLocaleString() || 0}</h3>
                </CardBody>
              </Card>
            </Col>
            <Col md={2}>
              <Card className="text-center" style={{backgroundColor: '#9E480E', color: 'white'}}>
                <CardBody>
                  <CardTitle tag="h6">Prom. Diario</CardTitle>
                  <h3>{datosCompletos.resumen.promedioDiario?.toLocaleString() || 0}</h3>
                </CardBody>
              </Card>
            </Col>
            <Col md={2}>
              <Card className="text-center" style={{backgroundColor: '#7030A0', color: 'white'}}>
                <CardBody>
                  <CardTitle tag="h6">Ticket Prom.</CardTitle>
                  <h4>{formatCurrency(datosCompletos.resumen.ticketPromedio)}</h4>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}

        {/* Gráficas Row 1 */}
        <Row className="mb-3">
          <Col md={6}>
            <div className="card">
              <div className="card-header">
                <h5>Prendas Vendidas por Vendedor</h5>
              </div>
              <div id="chartVendedor" style={{ width: "100%", height: "350px" }}></div>
            </div>
          </Col>
          <Col md={6}>
            <div className="card">
              <div className="card-header">
                <h5>Importe por Vendedor</h5>
              </div>
              <div id="chartImporteVendedor" style={{ width: "100%", height: "350px" }}></div>
            </div>
          </Col>
        </Row>

        {/* Gráficas Row 2 */}
        <Row className="mb-3">
          <Col md={6}>
            <div className="card">
              <div className="card-header">
                <h5>Top 15 Artículos Más Vendidos</h5>
              </div>
              <div id="chartArticulos" style={{ width: "100%", height: "350px" }}></div>
            </div>
          </Col>
          <Col md={6}>
            <div className="card">
              <div className="card-header">
                <h5>Prendas por Área/Tienda</h5>
              </div>
              <div id="chartArea" style={{ width: "100%", height: "350px" }}></div>
            </div>
          </Col>
        </Row>

        {/* Gráfica Tendencia */}
        <Row className="mb-3">
          <Col md={12}>
            <div className="card">
              <div className="card-header">
                <h5>Tendencia Diaria de Ventas</h5>
              </div>
              <div id="chartDiario" style={{ width: "100%", height: "300px" }}></div>
            </div>
          </Col>
        </Row>

        {/* Tablas de detalle */}
        <Row className="mb-3">
          <Col md={6}>
            <div className="card">
              <div className="card-header">
                <h5>Detalle por Vendedor</h5>
              </div>
              <div className="card-body" style={{maxHeight: '400px', overflowY: 'auto'}}>
                {datosCompletos && datosCompletos.porVendedor && (
                  <Table striped size="sm">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Vendedor</th>
                        <th className="text-right">Prendas</th>
                        <th className="text-right">Importe</th>
                      </tr>
                    </thead>
                    <tbody>
                      {datosCompletos.porVendedor.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.vendedor}</td>
                          <td className="text-right">{item.cantidad?.toLocaleString()}</td>
                          <td className="text-right">{formatCurrency(item.importe)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </div>
            </div>
          </Col>
          <Col md={6}>
            <div className="card">
              <div className="card-header">
                <h5>Top Artículos Más Vendidos</h5>
              </div>
              <div className="card-body" style={{maxHeight: '400px', overflowY: 'auto'}}>
                {datosCompletos && datosCompletos.topArticulos && (
                  <Table striped size="sm">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Código</th>
                        <th className="text-right">Prendas</th>
                        <th className="text-right">Importe</th>
                      </tr>
                    </thead>
                    <tbody>
                      {datosCompletos.topArticulos.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td title={item.descripcion}>{item.articulo}</td>
                          <td className="text-right">{item.cantidad?.toLocaleString()}</td>
                          <td className="text-right">{formatCurrency(item.importe)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </div>
            </div>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <Button
              size="sm"
              href="/MenuVentas"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Col>
        </Row>

      </div>
    </>
  );
}

export default ReporteVentasPorVendedor;
